import { createContext, useContext, useEffect, useState } from "react";

const ThemeContext = createContext(null);

function resolveDark(theme) {
  if (theme === "dark") return true;
  if (theme === "light") return false;
  return window.matchMedia("(prefers-color-scheme: dark)").matches;
}

export function ThemeProvider({ children }) {
  const [theme, setTheme] = useState(() => localStorage.getItem("mia-theme") || "system");
  const [dark, setDark] = useState(() => resolveDark(localStorage.getItem("mia-theme") || "system"));

  useEffect(() => {
    const apply = () => {
      const isDark = resolveDark(theme);
      setDark(isDark);
      document.documentElement.classList.toggle("dark", isDark);
    };
    apply();
    localStorage.setItem("mia-theme", theme);
    if (theme === "system") {
      const mq = window.matchMedia("(prefers-color-scheme: dark)");
      mq.addEventListener("change", apply);
      return () => mq.removeEventListener("change", apply);
    }
  }, [theme]);

  const toggle = () => setTheme(dark ? "light" : "dark");

  return (
    <ThemeContext.Provider value={{ theme, dark, setTheme, toggle }}>
      {children}
    </ThemeContext.Provider>
  );
}

export const useTheme = () => useContext(ThemeContext);
